import axios from 'axios';

// 判断是否为纷享者

export function isSharer() {
    return axios.get('/knowledge-operation/come-enjoy/has-identity-of-enjoyer');
}

// 纷享号内容列表
export function teamContentList(option) {
    return axios.get('/knowledge-operation/come-enjoy/come-enjoy-question', { params: option });
}

// 纷享号成员信息
export function memberInfo(option) {
    return axios.get('/knowledge-operation/come-enjoy/getenjoymembers', { params: option });
}


// 成员权限变更
export function memberChangeLevel(option) {
    return axios.post('/knowledge-operation/come-enjoy/update-members', option, { encode: true });
}

// 纷享号成就
export function teamAchievement(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-report', { params: option });
}

// 擅长话题
export function teamTopics(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-enjoy-relationtopics', { params: option });
}

// 学币相关
// 学币查账
export function totalCoinDetail(option) {
    return axios.get('/knowledge-operation/currency/total-amount', { params: option });
}

// 管理员分配学币
export function managerDistributeCoin(option) {
    return axios.post('/knowledge-operation/currency/admin-grant', { params: option });
}

// 纷享号分配学币
export function teamDistributeCoin(option) {
    return axios.post('/knowledge-operation/currency/enjoy-grant', option, { encode: true, loading: true });
}

// 学币列表
export function coinDetailList(option) {
    return axios.get('/knowledge-operation/currency/trade-detail', { params: option });
}

// 学币明细
export function coinDetail(option) {
    return axios.get('/knowledge-operation/currency/grant-detail', { params: option });
}
// 成员管理相关
// 纷享号验证码
export function inviteCode(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-invitecode', { params: option });
}

// 更新验证码
export function updateInviteCode(option) {
    return axios.get('/knowledge-operation/come-enjoy/update-invitecode', { params: option });
}


// 邀请码加入
export function joinTeamByCode(option) {
    return axios.post('/knowledge-operation/come-enjoy/join', option, { encode: true });
}

// 查询名称是否重复
export function nameRepeat(option) {
    return axios.get('/knowledge-operation/come-enjoy/checkNameExist', { params: option });
}


// 填写信息加入
export function joinTeamByApply(option) {
    return axios.post('/knowledge-operation/come-enjoy/apply', option, { encode: true });
}

// 获取加入结果
export function joinResult(option) {
    return axios.get('/knowledge-operation/come-enjoy/getnotice', { params: option });
}

// 认证在审数据
export function reviewData() {
    return axios.get('/knowledge-operation/come-enjoy/apply-verify');
}
